import chroma from "chroma-js";

function generateShades(input) {
  const color = chroma(input);
  if (CSS.supports("color", color.hex())) {
    return [
      {
        token: "neutral",
        rgb: color.rgb(),
      },
      {
        token: "light",
        // https://gka.github.io/chroma.js/#color-luminance
        rgb: color.luminance(0.85).rgb(),
      },
      {
        token: "dark",
        // https://gka.github.io/chroma.js/#color-darken
        rgb: color.darken(1.85).rgb(),
      },
    ];
  }
  throw new Error("Invalid primary color value.");
}

function setCssVars(palette) {
  const root = document.documentElement;
  palette.forEach(({ rgb, token }) => {
    const varName = `--colors-primary-${token}`;
    root.style.setProperty(varName, `rgb(${rgb.join(", ")})`);
    root.style.setProperty(`${varName}-rgb`, `${rgb.join(" ")}`);
  });
}

const defaultPrimaryColor = "#152C53";

export { generateShades, setCssVars, defaultPrimaryColor };
